export default  {"src":"/_next/static/image/public/images/icon_sm_wallet_dark.d1940e9a13e56f8bc7bf96411552e06d.svg","height":22,"width":23};